import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import Layout, { PageTitle, StatCard } from "@/components/Layout";
import { NAV_KEPSEK } from "@/lib/nav";
import { FilterBar } from "@/components/FilterBar";
import { GuruDetailModal } from "@/components/GuruDetailModal";
import BackupExcelButton from "@/components/BackupExcelButton";
import { Users, Eye } from "lucide-react";

const F_EMPTY = { q: "", jenis_kelamin: "", status: "" };

export function DataGuruKepsek() {
  const [all, setAll] = useState([]);
  const [stats, setStats] = useState({});
  const [filters, setFilters] = useState(F_EMPTY);
  const [applied, setApplied] = useState(F_EMPTY);
  const [detail, setDetail] = useState(null);

  const load = useCallback(async () => {
    try {
      const [{ data }, { data: st }] = await Promise.all([api.get("/guru"), api.get("/guru/stats")]);
      setAll(data); setStats(st);
    } catch (e) { console.error(e); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const items = all.filter((g) => {
    if (applied.q && !g.nama.toLowerCase().includes(applied.q.toLowerCase())) return false;
    if (applied.jenis_kelamin && g.jenis_kelamin !== applied.jenis_kelamin) return false;
    if (applied.status && g.status !== applied.status) return false;
    return true;
  });

  return (
    <Layout nav={NAV_KEPSEK}>
      <PageTitle title="Data Guru" action={<BackupExcelButton endpoint="guru" filters={applied} testId="backup-guru-btn" />} />
      <section className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <StatCard label="Guru Aktif" value={stats.aktif ?? 0} icon={Users} />
        <StatCard label="Tidak Aktif" value={stats.tidak_aktif ?? 0} icon={Users} />
        <StatCard label="Perempuan Aktif" value={stats.perempuan_aktif ?? 0} icon={Users} />
        <StatCard label="Laki-laki Aktif" value={stats.laki_aktif ?? 0} icon={Users} />
      </section>
      <FilterBar
        filters={filters} setFilters={setFilters}
        onApply={() => setApplied({ ...filters })}
        onReset={() => { setFilters(F_EMPTY); setApplied(F_EMPTY); }}
        dataTestidPrefix="kepsek-guru-filter"
        fields={[
          { key: "q", type: "text", label: "Nama", placeholder: "Cari nama guru" },
          { key: "jenis_kelamin", type: "select", label: "Jenis Kelamin", options: [{ v: "L", label: "Laki-laki" }, { v: "P", label: "Perempuan" }] },
          { key: "status", type: "select", label: "Status", options: [{ v: "aktif", label: "Aktif" }, { v: "tidak_aktif", label: "Tidak Aktif" }] },
        ]}
      />
      <section className="pp-card pp-freeze overflow-hidden">
        <table className="w-full text-sm">
          <thead><tr className="pp-table-header">
            <th className="text-left px-5 py-3">NIY</th>
            <th className="text-left px-5 py-3">Nama</th>
            <th className="text-left px-5 py-3">JK</th>
            <th className="text-left px-5 py-3">Pendidikan</th>
            <th className="text-left px-5 py-3">Status</th>
            <th className="text-right px-5 py-3">Aksi</th>
          </tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={6} className="text-center py-10 text-slate-400 italic">Belum ada data.</td></tr>}
            {items.map((g) => (
              <tr key={g.id} className="pp-row">
                <td className="px-5 py-3 font-mono text-xs">{g.niy}</td>
                <td className="px-5 py-3 font-medium">{g.nama}</td>
                <td className="px-5 py-3">{g.jenis_kelamin === "L" ? "L" : "P"}</td>
                <td className="px-5 py-3 text-slate-600 text-xs">{g.pendidikan_terakhir || "—"}</td>
                <td className="px-5 py-3"><span className={g.status === "aktif" ? "pp-badge-success" : "pp-badge-danger"}>{g.status}</span></td>
                <td className="px-5 py-3 text-right">
                  <button onClick={() => setDetail(g)} className="pp-btn-ghost text-xs" data-testid={`kepsek-guru-detail-${g.id}`}><Eye className="w-3.5 h-3.5" />Detail</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
      <GuruDetailModal detail={detail} onClose={() => setDetail(null)} />
    </Layout>
  );
}
